<template>
    <modal-template ref="modal">
        <template v-slot:title>
            {{ lang.modals?.ss?.headline }}
        </template>

        <template v-slot:default>
            <form action="" id="formSaveSearch">
                <div class="mb-4" v-html="lang.modals?.ss?.description"></div>

                <input-text
                    id="name"
                    name="name"
                    ref="inputName"
                    v-model="name"
                    :placeholder="lang.labels.saved_search_name"
                    :disabled="disableForm"
                    :required="true"
                ></input-text>
            </form>
        </template>

        <template v-slot:footer="footerSlotProps">
            <div class="grid grid-cols-2 gap-4">
                <plain-button
                    type="button"
                    class="btn btn-default"
                    @click="cancel"
                    :disabled="disableForm"
                    color="default"
                >{{lang.labels.cancel}}</plain-button>

                <plain-button
                    type="button"
                    class="btn btn-success"
                    @click="saveSearch"
                    :disabled="disableSendBtn"
                >
                    <span v-show="! showConfirmation">{{lang.labels.save}}</span><span  v-show="showConfirmation"><i class="fas fa-check"></i></span>
                </plain-button>
            </div>

        </template>

    </modal-template>

</template>

<script setup>
import { ref, computed } from 'vue';
import ModalTemplate from "./ModalTemplate.vue";
import InputText from "../inputs/InputText.vue";
import PlainButton from "../buttons/PlainButton.vue";

// Props
const props = defineProps({
    lang: Object,
    modalData: Object,
});

// Emits
const emit = defineEmits(['hide-modal']);

// Template refs
const modal = ref(null);
const inputName = ref(null);

// Reactive data
const disableForm = ref(false);
const name = ref('');
const showConfirmation = ref(false);

// Computed
const disableSendBtn = computed(() => {
    if (name.value === '') {
        return true;
    }

    if (disableForm.value) {
        return true;
    }

    return false;
});

// Methods
const showModal = () => {
    modal.value.showModal();
};

const hideModal = () => {
    modal.value.hideModal();
};

const pointCursorInNameField = () => {
    setTimeout(() => {
        // inputName.value.focus();
    }, 500);
};

const init = () => {
    name.value = '';
    showConfirmation.value = false;
    disableForm.value = false;

    showModal();
    pointCursorInNameField();
};

const saveSearch = () => {
    disableForm.value = true;

    axios.post(`/web-api/saved-search`, {
            name: name.value,
            searchQuery: props.modalData.searchQuery,
        })
        .then(response => {
            showConfirmation.value = true;

            setTimeout(() => {
                emit('hide-modal');
            }, 1000);
        })
        .catch(error => {
            // console.log(error)
        });
};

const cancel = () => {
    console.log('cancel');
    hideModal();
};

// Expose methods for parent component access
defineExpose({
    init,
    showModal,
    hideModal,
});
</script>
